import axios from 'axios';
import { analyticsEvent } from './analytics';
import { createOptions, share } from './share';
import basic from '../data/basic.json';
import { getResultImageGenerator } from './app/resultImageGenerator';
import { generateID as generateGUID } from '../../vendors/ngblib/utils/GUID';

// UTILS:
const objToGetParams = (data) => Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join('&');

const b64EncodeUnicode = (str) => btoa(encodeURIComponent(str).replace(
    /%([0-9A-F]{2})/g,
    (match, p1) => String.fromCharCode(`0x${p1}`)
));

const { settings } = basic;
const isProd = process.env.NODE_ENV === 'production';

const uploadImage = (bitmap) => new Promise((resolve, reject) => {
    if (!bitmap) {
        reject(new Error('Image must not be null'));

        return;
    }

    const guid = generateGUID();
    const fd = new FormData();

    fd.append('image', bitmap, `${guid}.jpg`);

    const config = {
        baseURL: settings.cloudFunctionsBaseUrl,
        headers: {
            Accept: 'application/json'
        }
    };

    if (isProd) {
        const str = b64EncodeUnicode('aWc6YWVjM2NoYXBlZTBvaFBoZWlobzdBc2E=');

        config.proxy = {
            host: 'proxy.park.rambler.ru',
            port: '8080',
            headers: {
                'Proxy-Authorization': `Basic ${str}`
            }
        };
    }

    axios
        .create(config)
        .post(settings.uploadFunction, fd)
        .then(
            (response) => {
                if (response.status === 200) {
                    resolve(response.data.imageUrl);

                    return;
                }

                reject(new Error(`Failed to upload the image with a status ${response.status}`));
            },
            (e) => {
                reject(new Error(`Failed to upload the image with an error ${e}`));
            }
        )
        .catch((e) => {
            reject(new Error(`Failed to upload the image with an error ${e}`));
        });
});

const registerListener = (btn, options) => {
    const { social } = btn.dataset;

    if (!social) return;

    btn.addEventListener('click', async () => {
        const finalOptions = createOptions(options);

        document.body.classList.add('share-result-loading');
        try {
            const bitmap = getResultImageGenerator().getBlob();

            console.log(bitmap);
            const image = await uploadImage(bitmap); // Upload image to firebase

            if (!image) {
                console.warn('Fail to construct result image to share. Default image is to be shared');
            }

            finalOptions.image = image;
            finalOptions.media = image;
            finalOptions.url += ((finalOptions.url.indexOf('?') > -1 ? '&' : '?') + objToGetParams({
                t: 'result',
                img: encodeURIComponent(image)
            }));
        } catch (e) {
            console.warn(`Fail to construct result image to share (${e}). Default image is to be shared`);
        }

        document.body.classList.remove('share-result-loading');

        analyticsEvent('results page', 'click', 'share');
        share(social, finalOptions);
    });
};

export const initShareButtons = (selector, options = {}) => {
    const btns = [...document.querySelectorAll(selector)];

    btns.forEach((btn) => {
        registerListener(btn, options);
    });
};
